<template>
  <div class="view-content view1">
    <div class="left">
      <div class="title">{{ $t('全球首个') }}</div>
      <div class="title">{{ $t('WEB3社区电商平台') }}</div>
      <div class="text">{{ $t('消费') }}<span class="text-margin">=</span>{{ $t('持股') }}<span class="text-margin">=</span>{{ $t('升值') }}</div>
      <div class="label">——{{ $t('重新定义消费的价值') }}</div>
    </div>
    <div class="right">
      <img class="img" src="./img/1030/view1-1.png">
    </div>
  </div>
</template>

<script>
export default {
  name: 'view1',
  data () {
    return {
      
    }
  },
}
</script>

<style scoped>
@import "./css/index.css";

</style>



// WEBPACK FOOTER //
// src/components/lobby/components1030/view1.vue